import { makeStyles } from '@material-ui/core'
import checkImage from '../../../../assets/png/check.png'

export const useStyles = makeStyles((theme) => ({
  input: {
    padding: 8,
    borderRadius: 4,
    margin: '8px 0 8px 0',
    width: 'calc(100% - 16px)',
    fontFamily: theme.app.typography.fontFamily.main,
    fontSize: theme.app.typography.paragraph.fontSize,
    border: 'none',

    '&:focus': {
      outline: 'none'
    },
    '&:disabled': {
      opacity: 0.5
    }
  },

  formInput: {
    width: '100%',
    marginBottom: 16
  },

  textarea: {
    padding: 8,
    height: 24,
    borderRadius: 4,
    margin: '8px 0 8px 0',
    width: 'calc(100% - 16px)',
    fontFamily: theme.app.typography.fontFamily.main,
    fontSize: theme.app.typography.paragraph.fontSize,
    border: 'none',
    background: `${theme.app.colors.input.background} no-repeat calc(100% - 16px) center`,
    minHeight: '100px',

    '&:focus': {
      outline: 'none'
    },

    '&:disabled': {
      opacity: 0.5
    }
  },

  formControl: {
    '& label': {
      color: theme.app.colors.text.primary,
      fontSize: theme.app.typography.label.fontSize
    }
  },

  '& .select-input__error': {
    top: 67,
    left: 0,
    display: 'block',
    width: '100%',
    position: 'absolute',
    color: theme.app.indication.danger,
    fontSize: theme.app.typography.error.fontSize,

    whiteSpace: 'normal',
    wordBreak: 'break-word'
  },

  buttonWrapper: {
    width: 'auto',
    padding: '8px 16px'
  },

  check: {
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '16px'
    },
    '& input': {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: '1px',
      margin: '-1px',
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      width: '1px'
    },

    '& label': {
      position: 'relative',
      paddingLeft: '2.2em',
      display: 'inline-block',
      cursor: 'pointer',

      '&::before': {
        content: '""',
        display: 'inline-block',
        verticalAlign: 'middle',
        height: '18px',
        width: '18px',
        background: theme.app.colors.border.dark,
        marginRight: '0.5em',
        transition: 'all 0.2s ease',
        position: 'absolute',
        top: '50%',
        left: '0',
        transform: 'translate(0, -50%)',
        borderRadius: '3px'
      },

      '&::after': {
        content: '""',
        position: 'absolute',
        background: 'no-repeat center center',
        backgroundImage: `url(${checkImage})`,
        top: '50%',
        left: '0.65em',
        transform: 'translate(-50%, -50%)',
        color: '#FFF',
        opacity: '0',
        transition: 'all 0.1s ease',
        width: '10px',
        height: '10px'
      }
    },

    '& input:checked + label::after': {
      opacity: 1
    }
  },

  formInputContainer: {
    display: 'flex',
    gap: 16,

    [theme.breakpoints.down('sm')]: {
      display: 'block'
    }
  },
  formFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 16,
    gap: 16,

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: 16,
      '& button': {
        width: '100%'
      }
    }
  }
}))
